import axios, { AxiosRequestConfig, AxiosError, InternalAxiosRequestConfig } from 'axios'
import { useUserStore } from '@/stores/user-store'

export const authApi = axios.create({
  baseURL: `${import.meta.env.VITE_HTTP_SCHEME}://${import.meta.env.VITE_BACKEND_HOST}/api/auth/`,
})

export const v1Api = axios.create({
  baseURL: `${import.meta.env.VITE_HTTP_SCHEME}://${import.meta.env.VITE_BACKEND_HOST}/api/v1/`,
})

function onFulfilledAuthRequest(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const userStore = useUserStore()
  const accessToken = userStore.getAccessToken()
  if (accessToken && config.headers) {
    config.headers['Authorization'] = accessToken
  }
  return config
}

async function onRejectedDefaultResponse(error: AxiosError) {
  if (error.response?.status === 401) {
    const userStore = useUserStore()
    const refreshResponse = await authApi
      .post('refresh', {}, { withCredentials: true })
      .catch((refreshError: AxiosError) => {
        console.log('Failed to refresh tokens:', refreshError)
        return undefined
      })

    if (refreshResponse?.status) {
      const authHeaderValue = userStore.saveAccessCredentials(
        refreshResponse.data.token_type,
        refreshResponse.data.access_token,
      )

      if (await userStore.isAuthenticated()) {
        const originalConfig: AxiosRequestConfig<any> | undefined = error.config
        if (originalConfig) {
          const configToRetry: AxiosRequestConfig = {
            ...originalConfig,
            headers: {
              ...originalConfig.headers,
              Authorization: authHeaderValue,
            },
          }
          return v1Api.request(configToRetry)
        }
      } else {
        window.location.href = '/auth/login'
      }
    }
  }
  return Promise.reject(error)
}

v1Api.interceptors.request.use(onFulfilledAuthRequest, (error) => Promise.reject(error))
v1Api.interceptors.response.use((response) => response, onRejectedDefaultResponse)
